import amountRequestedInput from './amount-requested-input';

export default amountRequestedInput;
